import { Component, TemplateRef } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { Store } from '@app/config/store';
import { provideIcons, NgIconComponent } from '@ng-icons/core';
import {
  matLockOutline,
  matLogoutOutline,
  matPowerSettingsNewOutline,
} from '@ng-icons/material-icons/outline';
import { Menu, SidenavComponent } from '../../shared/sidenav/sidenav.component';
import { PartnerStore } from '@app/config/partner-store';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { matPersonAdd } from '@ng-icons/material-icons/baseline';
import { ChangePasswordComponent } from '../auth/change-password/change-password.component';
import { ProductGuideService } from '@app/services/product-guide.service';

@Component({
  selector: 'app-partner',
  standalone: true,
  imports: [
    RouterOutlet,
    NgIconComponent,
    SidenavComponent,
    RouterLink,
    ChangePasswordComponent,
    NgbDropdownModule,
  ],
  templateUrl: './partner.component.html',
  styleUrl: './partner.component.css',
  providers: [
    provideIcons({ matLogoutOutline, matLockOutline, matPersonAdd, matPowerSettingsNewOutline }),
  ],
})
export class PartnerComponent {
  constructor(
    protected store: Store,
    protected partnerStore: PartnerStore,
    private ngbModal: NgbModal,
    private router: Router,
    private productGuideService: ProductGuideService,
  ) {}

  sidenavMenu: Menu[] = [
    {
      title: 'Dashboard',
      route: '',
      icon: '',
      menu: [
        {
          title: 'Organizations',
          route: '/partner/dashboard/organizations',
          icon: 'matGroups',
          access: true,
        },
        {
          title: 'User Manual',
          icon: 'matMenuBookOutline',
          click: () => this.getUserManual(),
          access: true,
        },
      ],
    },

    // {
    //   title: 'Manage',
    //   route: '',
    //   icon: '',
    //   menu: [
    //     {
    //       title: 'Partners',
    //       route: '/partner/manage/partners',
    //       icon: 'matPersonAdd',
    //       access: true,
    //     },
    //   ],
    // },
  ];

  openModal(content: TemplateRef<HTMLElement>, size = 'sm') {
    this.ngbModal.open(content, {
      centered: true,
      size,
    });
  }

  closeModal() {
    this.ngbModal.dismissAll();
  }

  whiteBackgroundRoutes = ['/partner/dashboard/organizations', '/partner/dashboard/org-info'];

  hasWhiteBg() {
    const url = this.router.url?.split('?')[0];
    return this.whiteBackgroundRoutes.includes(url);
  }

  getUserManual() {
    this.productGuideService.getPartnerUserManual().subscribe();
  }
}
